export default __webpack_public_path__ + "static/media/tortibrown.da97114c.jpeg";